// libraries
import { useState } from 'react';
import { Input, Modal, ModalFuncProps } from 'antd';

// resources
import { txt } from '../../../locales/i18n';

export function RemoveAccessModal(props: ModalFuncProps & { service: string }) {
	const [confirmText, setConfirmText] = useState<string>('');

	return (
		<Modal
			destroyOnClose
			closable={false}
			okButtonProps={{
				disabled: confirmText.toLowerCase() !== txt('global.remove access').toLowerCase(),
				danger: true,
			}}
			{...props}
		>
			<p>
				{txt('red-cross.confirm by typing')} <strong>{txt('global.remove access')}</strong>
			</p>

			<p
				dangerouslySetInnerHTML={{
					__html: txt('red-cross.remove volunteer modal text', { service: props.service }),
				}}
			/>
			<Input placeholder={txt('global.remove access')} onChange={(event) => setConfirmText(event.target.value)} />
		</Modal>
	);
}
